import {useEffect} from 'react';

import {faCircleCheck} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Text from 'components/Text/Text';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {setSuccessAC} from 'store/app/appSlice';
import './Success.scss';

interface IProps {
  success: string | null;
}

const Success = ({success}: IProps) => {
  const dispatch = useSetGlobalState();

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(setSuccessAC(null));
    }, 5000);

    return () => clearTimeout(timer);
  }, [dispatch, success]);

  return (
    <div className="success" data-testid="success">
      <div className="success__container">
        <div className="success__icon">
          <FontAwesomeIcon icon={faCircleCheck} />
        </div>
        <div className="success__message">
          <Text tag="h6">Success</Text>
          <Text tag="p">{success}</Text>
        </div>
      </div>
    </div>
  );
};

export default Success;
